import { message } from "antd";
import { MakeApiCall } from "../apis";
import dayjs from "dayjs";



export const ProjectName = "Seller View";

export const DefaultAdminPage = `/manage-user`;
export const DefaultUserPage = `/`;

export const ORIGIN = "https://app.sellerview.ai/sellerview_api";
export const ENDPOINT = `${ORIGIN}/api/v1/`;
export const Types = {
  1: "superAdmin",
  2: "user",
  3: "admin",
  4: "manager",
};


export const primaryColor = "#f45b68"; // medium
export const secondaryColor = "#16423C"; // dark
export const thirdColor = "#C4DAD2"; // light
export const BorderFilter = `1px solid ${primaryColor}`;
export const defaultPageSize = 20;

export const FormatUserName = (userName) => {
  // Replace hyphens with spaces
  let formattedName = userName?.replace(/-/g, " ");

  // Capitalize the first letter of each word
  formattedName = formattedName?.replace(/\b\w/g, function (char) {
    return char?.toUpperCase();
  });

  return formattedName === "Sku" ? "SKU" : formattedName;
};

export const RenderTable = (props, row, index, d, width) =>
  typeof d?.render === "function" ? (
    <>
      <div
        className="d-flex"
        style={{
          flexDirection: d?.align === "right" ? "row-reverse" : "row",
          minWidth: d?.title?.length * (10 + (width || 0)),
        }}
      >
        {d?.render(props, row, index)}
      </div>
    </>
  ) : (
    <>
      <div
        className="d-flex"
        style={{
          flexDirection: d?.align === "right" ? "row-reverse" : "row",
          minWidth: d?.title?.length * (10 + (width || 0)),
        }}
      >
        <span>{props || "-"}</span>
      </div>
    </>
  );


export const ConvertParams = (values) => {
  return Object.entries(
    Object.entries(values)
      .filter(
        ([_, value]) =>
          value &&
          value !== "" &&
          value !== undefined &&
          value !== null &&
          value?.length !== 0
      )
      .reduce((acc, [key, value]) => {
        acc[key] = encodeURIComponent(value);

        return acc;
      }, {})
  )
    ?.map((d, i) => {
      return `${i === 0 ? "?" : "&"}${d[0]}=${d[1] || ""}`;
    })
    ?.join("");
};


/**
 * Adds comma separators to numbers
 * @param {number|string} number - The number to format
 * @returns {string} Formatted number with commas
 */
export const AddCommas = (number) => {
  if (number === null || number === undefined || number === '') return '0';
  const parts = number.toString().split('.');
  let integerPart = parts[0];
  const decimalPart = parts.length > 1 ? '.' + parts[1] : '';

  // For numbers less than 4 digits, return as is
  if (integerPart.length <= 3) {
    return integerPart + decimalPart;
  }

  // Indian format: last 3 digits, then after every 2 digits
  const lastThree = integerPart.slice(-3);
  const otherNumbers = integerPart.slice(0, -3);

  let formatted = '';
  if (otherNumbers.length > 0) {
    formatted =
      otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + ',' + lastThree;
  } else {
    formatted = lastThree;
  }
  return formatted + decimalPart;
};

export const PaginationConfig = ({
  pageSize,
  currentPage,
  totalPage,
  onChange = () => {},
}) => {
  console.log(totalPage, " totalPage");
  return {
    pageSize: pageSize,
    current: currentPage,
    total: totalPage,
    onChange: (e, f) => {
      onChange(e, f);
    },
    showSizeChanger: true, // To show page size options
    pageSizeOptions: [10, 20, 50, 100], // Page size options
    showTotal: (total, range) =>
      `${AddCommas(range[0] || 0)}-${AddCommas(range[1] || 0)} of ${AddCommas(
        total || 0
      )} items`,
  };
};



export const GetMarketplaceList = (marketplaceList) =>
  marketplaceList
      .filter((d) => d.id === "A21TJRUUN4KGV") // Remove this filter once all marketplaces are supported
      .map((d, i) => {
    return {
      label: (
        <>
          <img
            src={`/assets/media/domainImage/${d?.id}.png`}
            style={{ height: "20px" }}
            loading="lazy"
            className="me-3"
            onError={(e) => {
              e.target.src = "/assets/media/domainImage/red-flag.png";
            }}
          />
          {/* {d?.id}({d?.name}) */}
          {d?.name}
          {/* {d?.name} <span style={{fontSize:'12px', opacity:'.5'}}>({d?.id})</span> */}
        </>
      ),
      value: d?.id,
    };
  });

  export const GetMarketplaceDropdown = async () => {
    try {
      const response = await MakeApiCall(
        "get-marketplaces",
        "get",
        null,
        true
      );
  
      if (response?.status) {
        return {
          marketplace_list: response?.data?.all_marketplaces || [],
          selected_marketplace: response?.data?.selected_marketplaces || [],
          // currency_list: response?.data?.currency_symbols || [],
        };
      } else {
        message.error(response?.message || "Unknown error occurred");
        return null;
      }
    } catch (error) {
      message.error(error.message || "An error occurred while fetching data");
      return null;
    }
  };


  export const rangePresets = [
    {
      label: "Today",
  
      value: [dayjs(), dayjs()],
    },
  
    {
      label: "Yesterday",
  
      value: [dayjs().add(-1, "d"), dayjs().add(-1, "d")],
    },
    {
      label: "This Month",
      value: [dayjs().startOf("month"), dayjs()],
    },
    {
      label: "Last Month",
      value: [
        dayjs().subtract(1, "month").startOf("month"),
        dayjs().subtract(1, "month").endOf("month"),
      ],
    },
    {
      label: "Last 7 Days",
  
      value: [dayjs().add(-6, "d"), dayjs()],
    },
  
    {
      label: "Last 14 Days",
  
      value: [dayjs().add(-13, "d"), dayjs()],
    },
  
    {
      label: "Last 30 Days",
  
      value: [dayjs().add(-29, "d"), dayjs()],
    },
  
    {
      label: "Last 90 Days",
  
      value: [dayjs().add(-89, "d"), dayjs()],
    },
  
    {
      label: "Custom Range",
  
      value: [0, 0],
    },
  ];